import { render, staticRenderFns } from "./AbsenceFileField.vue?vue&type=template&id=843b45fe&"
import script from "./AbsenceFileField.vue?vue&type=script&lang=js&"
export * from "./AbsenceFileField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('843b45fe')) {
      api.createRecord('843b45fe', component.options)
    } else {
      api.reload('843b45fe', component.options)
    }
    module.hot.accept("./AbsenceFileField.vue?vue&type=template&id=843b45fe&", function () {
      api.rerender('843b45fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/employee/permission/absences/fields/AbsenceFileField.vue"
export default component.exports